// extracted by mini-css-extract-plugin
export default {"box":"couponFilterPage_box__S6LFx","box__btn":"couponFilterPage_box__btn__ih+Vp"};